import { render } from "./FishBook.vue?vue&type=template&id=1f48d0a6&scoped=true"
import script from "./FishBook.vue?vue&type=script&lang=js"
export * from "./FishBook.vue?vue&type=script&lang=js"

import "./FishBook.vue?vue&type=style&index=0&id=1f48d0a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f48d0a6"]])

export default __exports__